import { useCallback, useRef } from 'react';

import { selectGetWorkspace } from '@/api/workspace/index.ts';
import { AddTabButton } from '@/App/tabs/AddTabButton.tsx';
import { LockWorkspaceButton } from '@/App/tabs/LockWorkspaceButton.tsx';
import { SaveButton } from '@/App/tabs/SaveButton.tsx';

import '@/App/tabs/Tabs.css';
import { ShareWorkspaceButton } from '@/App/tabs/ShareWorkspaceButton.tsx';
import { TabsList } from '@/App/tabs/TabsList.tsx';
import { WorkspacePicker } from '@/App/tabs/WorkspacePicker.tsx';
import { useAppSelector } from '@/store/hooks.ts';

export const APP_TABS_ID = 'tabs';

export function Tabs() {
  const { isLoading: isWorkspaceLoading } = useAppSelector(selectGetWorkspace());
  const scrollRef = useRef<HTMLUListElement>(null);

  const scrollToEnd = useCallback(() => {
    // Deferred to the next animation frame so React has committed the new tab
    // to the DOM first — otherwise scrollWidth still reflects the old list.
    requestAnimationFrame(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
      }
    });
  }, []);

  const handleWheel = useCallback((e: React.WheelEvent<HTMLUListElement>) => {
    if (scrollRef.current) {
      // noinspection JSSuspiciousNameCombination
      scrollRef.current.scrollLeft += e.deltaY;
    }
  }, []);

  return (
    <div id={APP_TABS_ID} className="bg-lvl1 d-flex justify-content-between">
      {isWorkspaceLoading ? null : (
        <>
          <ul ref={scrollRef} className="nav nav-tabs nav-lg ps-3 flex-nowrap flex-grow-1" onWheel={handleWheel}>
            <TabsList />

            <li className="nav-item-end" onClick={scrollToEnd}>
              <AddTabButton />
            </li>
          </ul>

          <div className="d-flex align-items-center border-bottom">
            <WorkspacePicker />
            <SaveButton />
            <ShareWorkspaceButton />
            <LockWorkspaceButton />
          </div>
        </>
      )}
    </div>
  );
}
